import { useState, useEffect } from 'react';
import squarespaceContent from '../utils/squarespaceContent';

export const useSquarespaceContent = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        setError(null);

        // Debug: Check if content is imported correctly
        console.log('Importing squarespaceContent:', squarespaceContent);
        console.log('Content type:', typeof squarespaceContent);
        console.log('Content keys:', squarespaceContent ? Object.keys(squarespaceContent) : 'null');

        // Use manual content import - return the full content object
        if (squarespaceContent && squarespaceContent.about) {
          setContent(squarespaceContent);
          console.log('Manual Content Loaded Successfully:', squarespaceContent);
        } else {
          throw new Error('Content structure is invalid or missing about section');
        }

      } catch (err) {
        console.error('Error loading manual content:', err);
        setError(err.message);
        // Set a fallback content structure
        setContent({
          about: {
            title: "About",
            heading: "Loading...",
            description: "Content is loading...",
            image: "",
            imageAlt: "Loading"
          }
        });
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  return { content, loading, error };
}; 